<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part">PART ONE</h1>
<h2 class="sub"><span class="scap">VISITOR FROM THE DEEP BLACK</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p01.vue?1b37c293